module.exports = __webpack_public_path__ + "img/shouye-daili-png.f32f3bc1.svg";